// extracted by mini-css-extract-plugin
module.exports = {"dateWrapper":"dateWrapper--2in_J","pdfIcon":"pdfIcon--3fmof"};